import { render, staticRenderFns } from "./editDividend.vue?vue&type=template&id=25e3226e&scoped=true&"
import script from "./editDividend.vue?vue&type=script&lang=js&"
export * from "./editDividend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e3226e",
  null
  
)

export default component.exports